import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { Post, backendUrlBase } from './common-types';
import { ROLES } from 'src/app/constants';

const roleApiSlice = createApi({
  reducerPath: ROLES,
  baseQuery: fetchBaseQuery({
    baseUrl: `${backendUrlBase}/api/roles`,
    credentials: 'include',
    mode: 'cors',
  }),
  endpoints: (builder) => ({
    getRolesFromServer: builder.query<Post[], unknown>({
      query() {
        return `/`;
      },
    }),
  }),
});

export const { useLazyGetRolesFromServerQuery } = roleApiSlice;
export default roleApiSlice;
